import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DatiqChecklistErrorTypes, IDatiqOption } from '@dat/datiq-components-pkg/utils';

export function maxCheckedItemsCheck(
    value: number | string | boolean | IDatiqOption[] | null,
    maxLength: number
): { [key: string]: any } | null {
    const valueIsArray: boolean = Array.isArray(value);
    const valid: boolean =
        !valueIsArray ||
        (valueIsArray && (value as IDatiqOption[]).length <= maxLength);

    return !!value && !valid
        ? {
              [DatiqChecklistErrorTypes.MaxCheckedItems]: {
                  currentLength: (value as IDatiqOption[]).length,
                  maxLength,
              },
          }
        : null;
}

export function maxCheckedItems(maxNumber: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        return maxCheckedItemsCheck(control.value, maxNumber);
    };
}
